import c from "config";
import {
  ADD_AGENT,
  ADD_AGENT_SUCCESS,
  ADD_AGENT_FAILED,
  FETCH_AGENTS,
  FETCH_AGENTS_SUCCESS,
  FETCH_AGENTS_FAILED,
  DELETE_AGENT,
  DELETE_AGENT_SUCCESS,
  DELETE_AGENT_FAILED,
  EDIT_AGENT,
  EDIT_AGENT_SUCCESS,
  EDIT_AGENT_FAILED,
  ADD_PP_AGENT,
  ADD_AGENT_PP_SUCCESS,
  ADD_AGENT_PP_FAILED,
  ADD_WEBSITE_AGENT,
  ADD_WEBSITE_AGENT_SUCCESS,
  ADD_WEBSITE_AGENT_FAILED
} from "../store/types";
import { cloud_function_server_url } from "config";
export const fetchAgent = (id) => (dispatch) => {
  dispatch({
    type: FETCH_AGENTS,
    payload: false
  });

  try {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "text/plain");
    myHeaders.append(
      "Authorization",
      "Basic ZXhkZXZAYXBpcHJvcGVydHkuY28uemE6QXByaWkyMDI0JA=="
    );
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append("Access-Control-Allow-Methods", "GET, POST, OPTIONS");
    myHeaders.append("Access-Control-Allow-Headers", "Content-Type");
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(
      `https://api.exdev.property24-test.com/listing/v50/agents/${id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        dispatch({
          type: FETCH_AGENTS_SUCCESS,
          payload: result
        });
        console.log("result", result);
      })
      .catch((error) => console.error(error));
  } catch (error) {
    dispatch({
      type: FETCH_AGENTS_FAILED,
      payload: error
    });
  }
};

export const addAgentP24 = (data, id) => (dispatch) => async (firebase) => {
  const { singleUserRef } = firebase;

  // console.log("data in the agent24", data)

  // console.log('data', data)

  // console.log("data in the agent24", data)

  // console.log('data', data)

  // Format phone number helper function
  const formatPhoneNumber = (number) => {
    if (!number) return "";
    // Convert +278XXXXXXXX to 0XXXXXXXXX
    if (number.startsWith("+27")) return "0" + number.slice(3);
    return number;
  };
  try {
    dispatch({
      type: ADD_AGENT,
      payload: false
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // const raw = JSON.stringify({
    //   firstname: data.userdetials.Name ? data.userdetials.Name : "",
    //   lastname: data.userdetials.lastName ? data.userdetials.lastName : "",
    //   //leave true
    //   receiveStatsMail: true,
    //   published: true,
    //   //
    //   agencyId: data.agencyId,
    //   cityId: data.cityId,
    //   sourceReference: data.userdetials.id,
    //   mobileNumber: formatPhoneNumber(data.userdetials.mobile)
    //     ? formatPhoneNumber(data.userdetials.mobile)
    //     : "",
    //   emailAddress: data.userdetials.email ? data.userdetials.email : "",
    //   isBroker: true,
    //   countryId: 1,
    //   profile: {
    //     id: 123,
    //     facebook: "https://www.facebook.com/MyAgency",
    //     twitter: "https://twitter.com/MyAgency"
    //   },
    //   status: "Active",
    //   jobTitle: "Broker"
    // });

    const raw = JSON.stringify({
      agentId: data.agentId || null,
      firstname: data.firstname || "",
      lastname: data.lastname || "",
      receiveStatsMail: true, // leave true
      published: true,
      agencyId: data?.agencyId,
      cityId: Number(data.cityId) ? Number(data.cityId) : 1,
      sourceReference: data.idNumber || "",
      mobileNumber: formatPhoneNumber(data.mobileNumber) || "",
      emailAddress: data.emailAddress || "",
      // faxNumber: data.faxNumber || "",
      // workNumber: data.workNumber || "",
      // qualification: data.qualification || "",
      // fidelityFundCertificationYear: data.fidelityFundCertificationYear || "",
      // fidelityFundCertificationNumber: data.fidelityFundCertificationNumber || "",
      idNumber: data.idNumber || "",
      // incomeTaxNumber: data.incomeTaxNumber || "",
      // about: data.about || "",
      profilePicture: data?.profilePicture ? data.profilePicture : {},
      isBroker: true,
      countryId: 1,
      // profilePicture: {
      //   bytes:
      //     "/9j/4AAQSkZJRgABAQEAYABgAAD/4QBmRXhpZgAATU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAAExAAIAAAAQAAAATgAAAAAAAABgAAAAAQAAAGAAAAABcGFpbnQubmV0IDQuMy44AP/bAEMAUDc8RjwyUEZBRlpVUF94yIJ4bm549a+5kcj////////////////////////////////////////////////////bAEMBVVpaeGl464KC6//////////////////////////////////////////////////////////////////////////AABEIAGQAZAMBIQACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/AG0V0GYUUAFFABRQAUUAFFABRQAUUAFFABRQAUUAFFABRQAUUAFFABRQAUUAFFABRQAUUAFFABRQAUUAFFABRQAUUAFFABRQAUUAFFABRQAUUAFFABRQAUUAFFACjrT5UCPgelK+oxVjUIGkJ56AUNGpQuhPHUGpuwsCxqE3uSAegFIwj25UnPoad3cBRGioGkJ56AUNGuzehOO+aV2FiKirEFFABRQAo6ipbgEyDAPSpe4+gso3RoR0AoQbYXJ4z0qelvMfUHG6JCBkDqKGCmEtsCnNH+YBOCQrDkYpACtu2eMnijoHUhorQkKKACigBaf50n979KTSe47iLIyfdPFIzs/3jmiyvcLgrsn3TilaRmGCeKLK9wuCyOowDxSM7P8AeOaLK9wuNopiCigAooAKKACigAooAKKACigAooAKKACigAooAKKACigAooAKKACigAooAKKACigAooAKKACigAooAKKACigAooAKKACigAooAKKACigAooAKKACigAooAKKAP//Z",
      //   mimeContentType: "image/jpeg",
      //   caption: "The kitchen"
      // },
      profile: {
        facebook: data.profile?.facebook || "",
        twitter: data.profile?.twitter || ""
      },
      status: data.status || "Active",
      jobTitle: data.jobTitle || "Broker"
      // Firebaseusertype: data.Firebaseusertype || "broker"
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/addAgent`, requestOptions)
      .then(async (response) => {
        console.log("this is the response Agent ===> ", response);
        // Parse response as JSON
        const result = await response.json();
        dispatch({
          type: ADD_AGENT_SUCCESS,
          payload: result
        });
        console.log("this is the response Agent ===> ", result);

        // Assuming the id is in result.agentId or result.id
        const agentId = result;

        if (agentId) {
          singleUserRef(id).update({
            agentId: agentId
          });
        }
        return agentId;
      })
      .catch((error) => {
        dispatch({
          type: ADD_AGENT_FAILED,
          payload: error.message
        });
        console.log(error.message);
        console.log(error);
      });
  } catch (error) {
    dispatch({ type: ADD_AGENT_FAILED, payload: error });
    console.log("error Agent", error);
  }
};

export const addPpAgent = (data, id, token) => (dispatch) => async (firebase) => {
  const { singleUserRef } = firebase;

  // Format phone number helper function
  // const formatPhoneNumber = (number) => {
  //   if (!number) return "";
  //   return number.replace(/(\+27)0(\d+)/, "$1$2").trim();
  // };
console.log('token in pp agent action', token)
console.log('data in pp agent action', data)
console.log('id in pp agent action', id)
  const formatPhoneNumber = (number) => {
    if (!number) return "";
    // Convert +278XXXXXXXX to 0XXXXXXXXX
    // if (number.startsWith("+27")) return "0" + number.slice(3);
    if (number.startsWith("+27")) number.slice(3);
    return number;
  };
  try {
    dispatch({
      type: ADD_PP_AGENT,
      payload: false
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "text/xml");

    const raw = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
         <soapenv:Header/>
         <soapenv:Body>
            <tem:UpdateAgent>
              <tem:Token>
                 <tem:Digest>${token.Digest}</tem:Digest>
                 <tem:UserName>${token.UserName}</tem:UserName>
                 <tem:StampTime>${token.StampTime}</tem:StampTime>
                 <tem:Expires>${token.Expires}</tem:Expires>
                 <tem:UID>${token.UID}</tem:UID>
              </tem:Token>
               <tem:Agent>
                  <tem:AgentId>${data.agentId}</tem:AgentId>
                  <tem:Active>${data.active}</tem:Active>
                  <tem:BranchId>${data.branchId}</tem:BranchId>
                  <tem:PrivysealAlias>${data.privysealAlias}</tem:PrivysealAlias>
                  <tem:FirstName>${data.firstName}</tem:FirstName>
                  <tem:LastName>${data.lastName}</tem:LastName>
                  <tem:IDNumber>${data.idNumber}</tem:IDNumber>
                  <tem:PassportNumber></tem:PassportNumber>
                  <tem:PassportCountryID></tem:PassportCountryID>
                  <tem:RegistrationNumber>${data.registrationNumber}</tem:RegistrationNumber>
                  <tem:VATNumber>${data.vatNumber}</tem:VATNumber>
                  <tem:Telephone></tem:Telephone>
                  <tem:TelCell>${data.telCell}</tem:TelCell>
                  <tem:TelWork>${data.telWork}</tem:TelWork>
                  <tem:Fax></tem:Fax>
                  <tem:Email>${data.email}</tem:Email>
               </tem:Agent>
            </tem:UpdateAgent>
         </soapenv:Body>
      </soapenv:Envelope>`;
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(
      `${cloud_function_server_url}/addPPAgent`,
      requestOptions
    )
      .then((response) => {
        response;
        dispatch({
          type: ADD_AGENT_PP_SUCCESS,
          payload: response
        });
        console.log("thies the response ===> ", response);
        return response.json();
      })
      .then((result) => {
        singleUserRef(id).update({
          PPagentId: result
        });

        console.log("result ===> ", result);
      })
      .catch((error) => {
        dispatch({
          type: ADD_AGENT_PP_FAILED,
          payload: error.message
        });
        console.log(error.message);
        console.log(error);
      });
  } catch (error) {
    dispatch({ type: ADD_AGENT_PP_FAILED, payload: error });
  }
};

export const addWebsite = (data, id) => (dispatch) => async (firebase) => {
  const { singleUserRef } = firebase;

  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "X-Joomla-Token",
      "c2hhMjU2OjQyOjk5YTliNmJmZGFkOGUzY2E2MTNjMmNhOTJmNGQxOTkyMWRjMGJkMzY0YzI0NjFlYjZlZGEwNTZlOTk1MDgzMWE="
    );

    const username = data.firstname.toLowerCase() + data.lastname.toLowerCase();

    const raw = JSON.stringify({
      block: 0,

      email: data.emailAddress || "",
      groups: data.groups || ["2"],
      id: data.id || "0",
      lastResetTime: data.lastResetTime || "",
      lastvisitDate: data.lastvisitDate || "",
      name: data.firstname || "",
      params: data.params || {
        admin_language: "",
        admin_style: "",
        editor: "",
        helpsite: "",
        language: "",
        timezone: ""
      },
      avatar: data?.profilePicture ? data.profilePicture : {},
      password: data.password || "",
      password2: data.password || "",
      registerDate: data.registerDate || "",
      requireReset: data.requireReset || "0",
      resetCount: data.resetCount || "0",
      sendEmail: data.sendEmail || "0",
      username: username || ""
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };
    // `${cloud_function_server_url}/addAgent`

    fetch(`${cloud_function_server_url}/addWebAgent`, requestOptions)
      .then((response) => {
        response;
        dispatch({
          type: ADD_WEBSITE_AGENT_SUCCESS,
          payload: response
        });
        return response.json();
      })
      .then((result) => {
        const websiteUserID = result?.data?.id;
        singleUserRef(id).update({
          websiteID: websiteUserID
        });
      })
      .catch((error) => console.error(error));
  } catch (error) {
    console.log("error in publish to  Api web", error.message);
    dispatch({
      type: ADD_WEBSITE_AGENT_FAILED,
      payload: `Sorry we recieved an error , ${error.code} : ${error.message}`
    });
  }
};

export const UpdateAgentP24 = (data, id) => (dispatch) => async (firebase) => {
  const { singleUserRef } = firebase;

  // console.log("data in the agent24", data)

  // console.log('data', data)

  // console.log("data in the agent24", data)

  // console.log('data', data)

  // Format phone number helper function
  const formatPhoneNumber = (number) => {
    if (!number) return "";
    // Convert +278XXXXXXXX to 0XXXXXXXXX
    if (number.startsWith("+27")) return "0" + number.slice(3);
    return number;
  };
  try {
    dispatch({
      type: ADD_AGENT,
      payload: false
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // const raw = JSON.stringify({
    //   firstname: data.userdetials.Name ? data.userdetials.Name : "",
    //   lastname: data.userdetials.lastName ? data.userdetials.lastName : "",
    //   //leave true
    //   receiveStatsMail: true,
    //   published: true,
    //   //
    //   agencyId: data.agencyId,
    //   cityId: data.cityId,
    //   sourceReference: data.userdetials.id,
    //   mobileNumber: formatPhoneNumber(data.userdetials.mobile)
    //     ? formatPhoneNumber(data.userdetials.mobile)
    //     : "",
    //   emailAddress: data.userdetials.email ? data.userdetials.email : "",
    //   isBroker: true,
    //   countryId: 1,
    //   profile: {
    //     id: 123,
    //     facebook: "https://www.facebook.com/MyAgency",
    //     twitter: "https://twitter.com/MyAgency"
    //   },
    //   status: "Active",
    //   jobTitle: "Broker"
    // });

    const raw = JSON.stringify({
      id: data.agentId || null,
      firstname: data.firstname || "",
      lastname: data.lastname || "",
      receiveStatsMail: true, // leave true
      published: true,
      agencyId: data.agencyId,
      cityId: Number(data.cityId) ? Number(data.cityId) : 1,
      sourceReference: data.idNumber || "",
      mobileNumber: formatPhoneNumber(data.mobileNumber) || "",
      emailAddress: data.emailAddress || "",
      // faxNumber: data.faxNumber || "",
      // workNumber: data.workNumber || "",
      // qualification: data.qualification || "",
      // fidelityFundCertificationYear: data.fidelityFundCertificationYear || "",
      // fidelityFundCertificationNumber: data.fidelityFundCertificationNumber || "",
      idNumber: data.idNumber || "",
      // incomeTaxNumber: data.incomeTaxNumber || "",
      // about: data.about || "",
      profilePicture: data?.profilePicture ? data.profilePicture : {},
      isBroker: true,
      countryId: 1,
      profile: {
        facebook: data.profile?.facebook || "",
        twitter: data.profile?.twitter || ""
      },
      status: data.status || "Active",
      jobTitle: data.jobTitle || "Broker"
      // Firebaseusertype: data.Firebaseusertype || "broker"
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${cloud_function_server_url}/UpdateAgent`, requestOptions)
      .then(async (response) => {
        // Parse response as JSON
        const result = await response.json();
        dispatch({
          type: ADD_AGENT_SUCCESS,
          payload: result
        });
        console.log("this is the response Agent ===> ", result);

        // Assuming the id is in result.agentId or result.id
        const agentId = result;

        if (!data.agentId && result && result.agentId) {
          singleUserRef(id).update({
            agentId: agentId
          });
        }
        return agentId;
      })
      .catch((error) => {
        dispatch({
          type: ADD_AGENT_FAILED,
          payload: error.message
        });
        console.log(error.message);
        console.log(error);
      });
  } catch (error) {
    dispatch({ type: ADD_AGENT_FAILED, payload: error });
    console.log("error Agent", error);
  }
};

export const UpdateWebsite = (data, id) => (dispatch) => async (firebase) => {
  const { singleUserRef } = firebase;

  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "X-Joomla-Token",
      "c2hhMjU2OjQyOjk5YTliNmJmZGFkOGUzY2E2MTNjMmNhOTJmNGQxOTkyMWRjMGJkMzY0YzI0NjFlYjZlZGEwNTZlOTk1MDgzMWE="
    );

    const username = data.firstname.toLowerCase() + data.lastname.toLowerCase();

    const raw = JSON.stringify({
      block: 0,

      email: data.emailAddress || "",
      groups: data.groups || ["2"],
      id: data.id || "0",
      lastResetTime: data.lastResetTime || "",
      lastvisitDate: data.lastvisitDate || "",
      name: data.firstname || "",
      params: data.params || {
        admin_language: "",
        admin_style: "",
        editor: "",
        helpsite: "",
        language: "",
        timezone: ""
      },
      avatar: data?.profilePicture ? data.profilePicture : {},
      password: data.password || "",
      password2: data.password || "",
      registerDate: data.registerDate || "",
      requireReset: data.requireReset || "0",
      resetCount: data.resetCount || "0",
      sendEmail: data.sendEmail || "0",
      username: username || ""
    });

    const requestOptions = {
      method: "PATCH",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };
    // `${cloud_function_server_url}/addAgent`

    fetch(`${cloud_function_server_url}/updateWebAgent`, requestOptions)
      .then((response) => {
        response;
        dispatch({
          type: ADD_WEBSITE_AGENT_SUCCESS,
          payload: response
        });
        return response.json();
      })
      .then((result) => {
        const websiteUserID = result?.data?.id;
        singleUserRef(id).update({
          websiteID: websiteUserID
        });
      })
      .catch((error) => console.error(error));
  } catch (error) {
    console.log("error in publish to  Api web", error.message);
    dispatch({
      type: ADD_WEBSITE_AGENT_FAILED,
      payload: `Sorry we recieved an error , ${error.code} : ${error.message}`
    });
  }
};
